export default {"src":"/_next/static/media/instagram.eb300dc2.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};